import { render, staticRenderFns } from "./ResponseForm.vue?vue&type=template&id=44afb9c8&scoped=true"
import script from "./ResponseForm.vue?vue&type=script&lang=js"
export * from "./ResponseForm.vue?vue&type=script&lang=js"
import style0 from "./ResponseForm.vue?vue&type=style&index=0&id=44afb9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44afb9c8",
  null
  
)

export default component.exports